/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
import { observer } from "mobx-react";
import {
  Flex,
  Text,
  Image,
  Button,
  createStyles,
  rem,
  Switch,
  Tooltip,
} from "@mantine/core";
import { useStore } from "../../../../hooks/use-store";
import { useRequest } from "ahooks";
import { NOTIFICATION_SERVICE } from "../../../../components/notifications/NotificationService";
import { PromptField } from "./PromptField";
import { PipelineParameters } from "../Pipeline";
import { useRef, useState } from "react";
import { Widget } from "@uploadcare/react-widget";
// import { useHistory } from "react-router-dom";
import { priceMap } from "../Router";
import ImageObserved from "../Image";
import { SidebarTrigger } from "./Sidebar";
import BottomButton from "./BottomButton";
import orbitGif from "../images/0kipbctj32tj1c0u5qsshl0tv9bud9.jpeg";
import craneGif from "../images/3vnt3j1q67bju1ptyatkppzy3jsz98.jpeg";
import dollyGif from "../images/o326au6x3oniiw0g1myn4329u3b0qx.jpeg";
import carFollowGif from "../images/sbt01qfvx6ozd0a3wd6o96m5gfz9l3.jpeg";
import heroGif from "../images/z52t3shyabhju70qtp1n22h9we73kf.jpeg";
import parking from "../images/parking.jpg";
import { useHistory } from "react-router-dom";

// Kontext-related rectangle editor removed

const useStyles = createStyles((theme) => ({
  uploadContainer: {
    backgroundColor: '#4f4f4f',
    borderRadius: '4px',
    height: '288px',
    overflow: 'hidden',
  },
  widgetRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    '> div': {
      textAlign: 'center',
    }
  }
}));

const ratioOptions = [
  { label: '3:2', value: 3 / 2, width: 3, height: 2 },
  { label: '1:1', value: 1, width: 1, height: 1 },
  { label: '2:3', value: 2 / 3, width: 2, height: 3 },
  { label: '16:9', value: 16 / 9, width: 16, height: 9 },
  { label: '9:16', value: 9 / 16, width: 9, height: 16 },
];

const Element = (model: {
  buy: (params: PipelineParameters[]) => Promise<void>;
  loading: boolean
}) => {

  // Single supported model: nanoBanana

  const history = useHistory();

  const {
    uiStore: { authStore },
    dataStore: { spaceStore, appStore },
  } = useStore();

  // Removed kontext stage editor

  // const handleExport = async () => {
  //   const uri = stageRef.current.toDataURL();
  //   console.log(uri);
  //   // we also can save uri as file
  //   // but in the demo on Konva website it will not work
  //   // because of iframe restrictions
  //   // but feel free to use it in your apps:
  //   // downloadURI(uri, 'stage.png');
  // };

  const { classes } = useStyles();

  // const history = useHistory();

  // const [imageSrc, setImageSrc] = useState<null | { url: string }>(null);
  // const [initialImageSrc, setInitialImageSrc] = useState<null | { url: string }>(null);
  const [customLoading, setCustomLoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedRatio, setSelectedRatio] = useState(ratioOptions[0]); // Default to 3:2
  const [selectedSize, setSelectedSize] = useState<'1K' | '2K' | '4K'>('4K');
  const sizeMultiplier = selectedSize === '1K' ? 1 : selectedSize === '2K' ? 2 : 4;
  const computedCredits = priceMap.PLACE_CAR * sizeMultiplier;
  const [mode, setMode] = useState<'standard' | 'advanced'>('standard');
  const uploadWidgetRef = useRef<HTMLDivElement | null>(null);
  const openUploadDialog = () => {
    const button = uploadWidgetRef.current?.querySelector('button');
    if (button) (button as HTMLButtonElement).click();
  }

  // Removed kontext editor states

  // Calculate canvas size based on selected ratio
  const calculateCanvasSize = (ratio: number, baseSize: number) => {
    if (ratio >= 1) {
      // Landscape or square - width is base, height is scaled
      return {
        width: baseSize,
        height: baseSize / ratio
      };
    } else {
      // Portrait - height is base, width is scaled
      return {
        width: baseSize * ratio,
        height: baseSize
      };
    }
  };

  // Fixed preview size for Nano Banana (do not react to ratio changes)
  const nanoCanvasSize = {
    small: calculateCanvasSize(ratioOptions[0].value, 800),
    big: calculateCanvasSize(ratioOptions[0].value, 1400)
  }
  // Removed kontext background image handling

  const { loading: runAsyncConvertLoading, runAsync: runAsyncConvert } = useRequest(
    async (model: { url: string, removeBackground?: boolean }) => appStore.convertImage(model),
    {
      manual: true,
      onSuccess: (res) => {
        if (res.error) {
          NOTIFICATION_SERVICE.errorNotification(
            "Sorry, service is unavailable due to high demand. Please try later"
          );
        } else {
          return res.url
        }
      },
    }
  );

  // Removed kontext base64 conversion flow



  return (
    <Flex direction={'column'} w="100%" pos='relative' gap={12} mt={20} mb={60}>

      <Flex
        style={{
          position: 'absolute',
          top: '80px',
          left: '50%',
          transform: 'translate(420px, 0)',
        }}
      >
        <Flex
          direction="column"
          gap={12}
          style={{
            width: '320px',
            position: 'relative',
            padding: '18px',
            backgroundColor: 'rgba(32, 32, 32, 1)',
            borderRadius: '8px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}
        >
          <Flex gap={8}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 1.96973H8C4 1.96973 2 3.96973 2 7.96973V12.9697C2 17.9697 4 18.9697 8 18.9697H8.5C8.78 18.9697 9.14 19.1497 9.3 19.3697L10.8 21.3697C11.46 22.2497 12.54 22.2497 13.2 21.3697L14.7 19.3697C14.89 19.1197 15.19 18.9697 15.5 18.9697H16C20 18.9697 22 16.9697 22 12.9697V7.96973C22 3.96973 20 1.96973 16 1.96973ZM8.53 12.1697C8.82 12.4597 8.82 12.9397 8.53 13.2297C8.38 13.3797 8.19 13.4497 8 13.4497C7.81 13.4497 7.62 13.3797 7.47 13.2297L5.47 11.2297C5.18 10.9397 5.18 10.4597 5.47 10.1697L7.47 8.16973C7.76 7.87973 8.24 7.87973 8.53 8.16973C8.82 8.45973 8.82 8.93973 8.53 9.22973L7.06 10.6997L8.53 12.1697ZM13.69 8.65973L11.69 13.3297C11.57 13.6097 11.29 13.7797 11 13.7797C10.9 13.7797 10.8 13.7597 10.7 13.7197C10.32 13.5597 10.14 13.1197 10.31 12.7297L12.31 8.05973C12.47 7.67973 12.91 7.49973 13.3 7.66973C13.68 7.83973 13.85 8.27973 13.69 8.65973ZM18.53 11.2297L16.53 13.2297C16.38 13.3797 16.19 13.4497 16 13.4497C15.81 13.4497 15.62 13.3797 15.47 13.2297C15.18 12.9397 15.18 12.4597 15.47 12.1697L16.94 10.6997L15.47 9.22973C15.18 8.93973 15.18 8.45973 15.47 8.16973C15.76 7.87973 16.24 7.87973 16.53 8.16973L18.53 10.1697C18.82 10.4597 18.82 10.9397 18.53 11.2297Z" fill="#BDBDBD" />
            </svg>


            <Text color="white" size={'sm'} fw={700}>
              Info & Examples
            </Text>
          </Flex>

          <Text color="rgba(189, 189, 189, 1)" size={'sm'}>
            Upload any photo of your car, then position it where you want it to appear in the final visual. The background you select works as a mood reference, while our AI taps into the entire MAGROUND library to generate the most accurate and photoreal marketing visuals possible.
          </Text>
          {/* Upload buttons below Info & Examples */}
          <Flex direction="column" gap={12}>
            {/* Car photo upload */}
            <Flex
              w="100%"
              justify="center"
              align="center"
              bg="#1b1b1b"
              className={classes.uploadContainer}
              style={{ border: '2px dashed #404040', padding: '12px' }}
            >
              {spaceStore.carImg ? (
                <Flex direction="column" gap={8} w="100%" justify="center" align="center">

                  <Image
                    mt={10}
                    src={spaceStore.carImg}
                    width={'100%'}
                    height={'auto'}
                    fit="contain"
                    style={{ borderRadius: '6px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', padding: '14px' }}
                  />
                  <Flex justify="flex-end">
                    <Button
                      mb={30}
                      variant="subtle"
                      color="red"
                      size="xs"
                      onClick={() => {
                        spaceStore.setCarImg('');
                        // setImageSrc(null);
                        // setInitialImageSrc(null);
                      }}
                    >
                      Remove
                    </Button>
                  </Flex>
                </Flex>
              ) : (
                <>
                  {/* Hidden Uploadcare widget used as a dialog opener */}
                  <div ref={uploadWidgetRef} style={{ position: 'absolute', left: '-9999px', top: '-9999px', width: 0, height: 0, overflow: 'hidden' }}>
                    <Widget
                      imagesOnly
                      localeTranslations={{
                        buttons: {
                          choose: {
                            images: {
                              one: 'Upload your car image'
                            },
                          },
                        },
                      }}
                      clearable={false}

                      onFileSelect={async () => {
                        setCustomLoading(true)
                       
                      }}
                      onChange={async (info: {
                        crop?: {
                          width: number
                          height: number
                        },
                        cdnUrl: string,
                        originalImageInfo: {
                          width: number
                          height: number
                        }
                      }) => {
                        setCustomLoading(true)
                        const res = await runAsyncConvert({ url: info.cdnUrl, removeBackground: false })
                        setCustomLoading(false)
                        spaceStore.setCarImg(res.url)
                      }}
                      tabs={"file camera url"}
                      publicKey="35626f59762b63c4244c"
                      previewStep={false}
                    />
                  </div>

                  {/* Custom upload card matching visual spec */}
                  <Flex
                    direction="column"
                    align="center"
                    justify="center"
                    w="100%"
                    h="100%"
                    onClick={openUploadDialog}
                    style={{ cursor: 'pointer', userSelect: 'none', textAlign: 'center' }}
                  >

                    {
                      customLoading ? (
                        <Text color="white" fw={600} size="lg" style={{ marginBottom: '6px' }}>Loading...</Text>
                      ) : (
                        <>
                          <Text color="white" fw={600} size="lg" style={{ marginBottom: '6px' }}>Car Photo</Text>
                          <Text color="#BDBDBD" size="sm" style={{ marginBottom: '16px' }}>Upload your car image</Text>
                          <Flex gap={6} align="center">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 16V4" stroke="#BDBDBD" strokeWidth="1.5" strokeLinecap="round" />
                              <path d="M8 8L12 4L16 8" stroke="#BDBDBD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M4 20H20" stroke="#BDBDBD" strokeWidth="1.5" strokeLinecap="round" />
                            </svg>
                            <Text color="#BDBDBD" size="sm">JPG, PNG up to 10MB</Text>
                          </Flex>
                        </>
                      )
                    }

                  </Flex>
                </>
              )}
            </Flex>

            <Flex
              w="100%"
              justify="center"
              align="center"
              bg="#1b1b1b"
              h={100}
              className={classes.uploadContainer}
              onClick={() => {
                history.push('/gallery')
              }}
              style={{ border: '2px dashed #404040', padding: '12px', cursor: 'pointer' }}
            >
              <Text color="white" size={'sm'} fw={700}>
                Select another Location
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>

      {/* Ratio Selector */}
      <Flex mb={16} justify="space-between">
        <Flex gap={8} p={12} style={{
          backgroundColor: 'rgba(32, 32, 32, 1)',
          borderRadius: '8px',
          border: '1px solid rgba(189, 189, 189, 0.2)'
        }}>
          <Text color="white" size="sm" fw={600} style={{ alignSelf: 'center' }}>
            Aspect Ratio:
          </Text>
          {ratioOptions.map((ratio) => (
            <Button
              key={ratio.label}
              size="xs"
              variant={selectedRatio.label === ratio.label ? "filled" : "outline"}
              color={selectedRatio.label === ratio.label ? "orange" : "gray"}
              onClick={() => {
                setSelectedRatio(ratio);
              }}
              style={{ minWidth: '50px' }}
            >
              {ratio.label}
            </Button>
          ))}
        </Flex>
        <Flex gap={8} p={12}
          align={'center'}
          style={{
            backgroundColor: 'rgba(32, 32, 32, 1)',
            borderRadius: '8px',
            border: '1px solid rgba(189, 189, 189, 0.2)'
          }}>
          <Text color="white" size="sm" fw={600} style={{ alignSelf: 'center' }}>
            Size:
          </Text>
          {(['1K', '2K', '4K'] as const).map((size) => (
            <Button
              key={size}
              size="xs"
              variant={selectedSize === size ? "filled" : "outline"}
              color={selectedSize === size ? "orange" : "gray"}
              onClick={() => setSelectedSize(size)}
              style={{ minWidth: '50px' }}
            >
              {size}
            </Button>
          ))}
         
        </Flex>
        <Flex gap={8} p={12}
          align={'center'}
          style={{
            backgroundColor: 'rgba(32, 32, 32, 1)',
            borderRadius: '8px',
            border: '1px solid rgba(189, 189, 189, 0.2)'
          }}>
          <Text color="white" size="sm" fw={600} style={{ alignSelf: 'center' }}>
            Mode:
          </Text>
          <Switch
            size="md"
            color="orange"
            onLabel="Advanced"
            offLabel="Standard"
            checked={mode === 'advanced'}
            onChange={(event) => setMode(event.currentTarget.checked ? 'advanced' : 'standard')}
            styles={{
              label: { color: 'white', fontWeight: 600 },
            }}
          />
        </Flex>
      </Flex>

      <Flex direction={'column'} gap={6}>
        <Flex
          w={`${nanoCanvasSize.small.width}px`}
          h={`${nanoCanvasSize.small.height}px`}
          style={{
            borderRadius: '6px',
            // border: '2px solid #84cc15',
            position: 'relative', overflow: 'hidden'
          }}>


          <Flex gap={2} justify={'center'} w={'100%'} align={'center'} style={{ zIndex: 10 }} bg='white'>
            <Flex w="100%" h={0} justify={'center'} style={{ position: 'relative' }}>
              {spaceStore.selectedImage && (
                <Flex
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    // opacity: 0.4,
                    zIndex: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                  <Image
                    src={spaceStore.selectedImage}
                    width={nanoCanvasSize.small.width + 'px'}
                    height={nanoCanvasSize.small.height + 'px'}
                    fit="cover"
                  />
                </Flex>
              )}


            </Flex>

          </Flex>

          {/* <App image={'/android-chrome-512x512.png'} /> */}
        </Flex>

      </Flex>

      {mode === 'advanced' ? (
        <PromptField
          credits={computedCredits}
          disabled={false}
          onClick={async () => {
            const pipeline: PipelineParameters = {
              provider: 'custom',
              type: 'nanoBananaPlaceCar2',
              size: selectedSize,
              prompt: spaceStore.prompt || '',
              hiddenPrompt: spaceStore.prompt || '',
              ratio: selectedRatio.label,
              carSrc: spaceStore.carImg,
              inputSrc: spaceStore.carImg,
              backgroundSrc: spaceStore.selectedImage!,
              credits: computedCredits,
              srcset: []
            }
            await model.buy([pipeline])
          }}
          value={spaceStore.prompt || ''}
          onChangeEnd={(value) => {
            spaceStore.setPrompt(value)
          }}
          loading={model.loading}
          placeholder="Describe your desired result (optional)"
        >
          <></>
        </PromptField>
      ) : (
        <Flex justify="flex-end" mt={8}>
          <Tooltip p={12} label={
            <span>Generation cost: <span style={{
              color: '#f53c02',
              fontWeight: 700
            }}>{computedCredits} credits</span>
            </span>
          } withArrow position="right" color='dark'>
            <Button
              size="lg"
              color="orange"
              loading={model.loading}
              onClick={async () => {
                const pipeline: PipelineParameters = {
                  provider: 'custom',
                  type: 'nanoBananaPlaceCar2',
                  prompt: '',
                  hiddenPrompt: '',
                  ratio: selectedRatio.label,
                  carSrc: spaceStore.carImg,
                  inputSrc: spaceStore.carImg,
                  backgroundSrc: spaceStore.selectedImage!,
                  size: selectedSize,
                  credits: computedCredits,
                  srcset: []
                }
                await model.buy([pipeline])
              }}
            >
              <Flex gap={8} align="center">

                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21.9169 16.13C21.922 16.3487 21.8553 16.563 21.7269 16.74C21.6003 16.9206 21.4174 17.0542 21.2069 17.12L19.4969 17.69C18.9702 17.865 18.4911 18.1593 18.0969 18.55C17.7033 18.9419 17.4085 19.4217 17.2369 19.95L16.6369 21.65C16.5744 21.8541 16.4483 22.0328 16.2769 22.16C16.0941 22.2842 15.878 22.3504 15.6569 22.35C15.4351 22.3595 15.2164 22.2949 15.0353 22.1663C14.8543 22.0378 14.7211 21.8526 14.6569 21.64L14.0869 19.93C13.9154 19.4017 13.6206 18.9219 13.2269 18.53C12.8296 18.1411 12.3516 17.8441 11.8269 17.66L10.1169 17.1C9.91451 17.0291 9.73723 16.9005 9.60695 16.73C9.47565 16.5495 9.40241 16.3332 9.39695 16.11C9.38747 15.8882 9.4521 15.6695 9.58065 15.4884C9.70921 15.3074 9.89437 15.1742 10.1069 15.11L11.8269 14.54C12.3604 14.3677 12.8452 14.0711 13.2416 13.6747C13.638 13.2783 13.9346 12.7935 14.1069 12.26L14.6769 10.57C14.7352 10.3621 14.8593 10.1786 15.0305 10.047C15.2018 9.91544 15.411 9.84282 15.6269 9.84004C15.8419 9.84004 16.0529 9.89904 16.2369 10.01C16.4189 10.135 16.5589 10.313 16.6369 10.52L17.2169 12.26C17.3893 12.7935 17.6859 13.2783 18.0823 13.6747C18.4787 14.0711 18.9635 14.3677 19.4969 14.54L21.1969 15.14C21.4038 15.2078 21.5828 15.3412 21.7069 15.52C21.8424 15.6946 21.9163 15.9091 21.9169 16.13ZM11.9179 9.77004C11.9164 9.96607 11.8573 10.1573 11.7479 10.32C11.6297 10.481 11.4661 10.6029 11.2779 10.67L10.0179 11.09C9.66495 11.212 9.34495 11.41 9.07795 11.67C8.81695 11.9362 8.61878 12.2574 8.49795 12.61L8.06795 13.85C8.00698 14.0414 7.88378 14.2068 7.71795 14.32C7.55355 14.4348 7.35844 14.4975 7.15795 14.5C6.95296 14.4966 6.75398 14.4303 6.58795 14.31C6.43067 14.1904 6.31235 14.0269 6.24795 13.84L5.83795 12.59C5.71764 12.2401 5.51931 11.922 5.25795 11.66C5.00184 11.3913 4.68191 11.1918 4.32795 11.08L3.07795 10.66C2.88399 10.599 2.71538 10.476 2.59795 10.31C2.51835 10.1854 2.4674 10.0446 2.44876 9.89787C2.43013 9.75113 2.44428 9.60209 2.49019 9.46149C2.5361 9.32088 2.61263 9.19221 2.71427 9.08475C2.81591 8.97729 2.94012 8.89371 3.07795 8.84004L4.32795 8.43004C4.68164 8.30654 5.00292 8.10482 5.26782 7.83992C5.53273 7.57501 5.73445 7.25374 5.85795 6.90004L6.26795 5.67004C6.32689 5.48571 6.43805 5.32244 6.58795 5.20004C6.74723 5.08002 6.93877 5.01037 7.13795 5.00004C7.33974 4.99462 7.53845 5.0504 7.70795 5.16004C7.87476 5.27265 8.00372 5.43297 8.07795 5.62004L8.49795 6.90004C8.62145 7.25374 8.82316 7.57501 9.08807 7.83992C9.35298 8.10482 9.67425 8.30654 10.0279 8.43004L11.2779 8.86004C11.4649 8.92426 11.6262 9.04698 11.7379 9.21004C11.8563 9.37264 11.9194 9.56892 11.9179 9.77004ZM17.7069 4.41004C17.6979 4.59237 17.6391 4.76874 17.5369 4.92004C17.4329 5.06264 17.2856 5.16786 17.1169 5.22004L16.4969 5.43004C16.3765 5.4716 16.2671 5.54002 16.177 5.63011C16.0869 5.7202 16.0185 5.8296 15.9769 5.95004L15.7569 6.58004C15.6966 6.73345 15.5965 6.86804 15.4669 6.97004C15.3195 7.08814 15.1358 7.15173 14.9469 7.15004C14.7741 7.13931 14.6062 7.08792 14.4569 7.00004C14.3074 6.8899 14.1957 6.73621 14.1369 6.56004L13.9269 5.94004C13.8908 5.81708 13.8217 5.70639 13.7269 5.62004C13.6388 5.52753 13.5287 5.45874 13.4069 5.42004L12.7869 5.22004C12.622 5.15571 12.477 5.04874 12.3669 4.91004C12.2632 4.76016 12.2074 4.58232 12.2069 4.40004C12.2128 4.21712 12.2718 4.03987 12.3769 3.89004C12.4847 3.75118 12.6307 3.64689 12.7969 3.59004L13.4069 3.39004C13.5301 3.34802 13.6427 3.27978 13.7369 3.19004C13.8267 3.09579 13.8949 2.98321 13.9369 2.86004L14.1469 2.24004C14.2069 2.08504 14.3019 1.94804 14.4269 1.84004C14.5704 1.73415 14.7396 1.66855 14.9169 1.65004C15.1057 1.64896 15.2903 1.70471 15.4469 1.81004C15.5879 1.91609 15.6983 2.05754 15.7669 2.22004L15.9769 2.86004C16.019 2.98321 16.0872 3.09579 16.1769 3.19004C16.27 3.27641 16.3786 3.34429 16.4969 3.39004L17.1269 3.60004C17.2872 3.66308 17.4284 3.76641 17.5369 3.90004C17.646 4.04783 17.7055 4.22636 17.7069 4.41004Z" fill="white" />
                </svg>
                <Text color="white" size="sm" fw={600}>Generate</Text>
              </Flex>

            </Button>
          </Tooltip>
        </Flex>
      )}
    </Flex>
  );
};

export const PlaceCar = observer(Element);